import loadable from '@loadable/component';

export const AsyncHomePage = loadable(
  () => import(/* webpackChunkName: "AsyncHomePage" */ 'components/Homepage')
);

export const AsyncMarkets = loadable(
  () =>
    import(
      /* webpackChunkName: "AsyncMarkets", webpackPrefetch: true */ 'containers/markets'
    )
);

export const AsyncTrade = loadable(
  () =>
    // ? already prefetched in useMobileDrawerPreload
    import(/* webpackChunkName: "AsyncTrade" */ 'containers/trade')
);

export const AsyncTradingViewChart = loadable(
  // ? keep same chunkname throughout codebase, already prefetched in useMobileDrawerPreload
  () => import(/* webpackChunkName: "Charts" */ 'components/chart/charts_new')
);
